module.exports = __webpack_public_path__ + "static/media/uz.f32eacef.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/uz.svg
// module id = 797
// module chunks = 0